import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import {
  userIsLogged,
  apiGetAvpAssistente,
  apiDeleteAvpAssistente,
  apiCloneAvpAssistente,
  getRoute,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useGraphStore } from "../new-avp/test-graph/store";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneAvpScreen() {
  const { setSelectedLingua, setSelectedNode, setAvp } = useGraphStore(
    (state) => state
  );
  const navigate = useNavigate();

  const { selectedLinguaTesto } = useLingueStore((state) => state);

  const [rows, setRows] = useState([]);
  const [avpStatus, setAvpStatus] = useState(0);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [cloneDialogOpen, setCloneDialogOpen] = useState(false);
  const [idAvpToClone, setIdAvpToClone] = useState(null);
  const [idAvpToDelete, setIdAvpToDelete] = useState(null);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);

  const breadCrumb = [{ title: "Gestione AVP", link: "" }];

  useEffectOnce(() => {
    setAvp(null);
    setSelectedLingua(undefined);
    setSelectedNode(undefined);
    startPage();

    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");

    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 20)) {
        navigate("/");
      }
      initPage();
    }
  }

  function initPage() {
    console.log("initPage");

    apiGetAvpAssistente(avpStatus, avpIstanzeCallback);
  }

  function stopPage() {
    console.log("stopPage");
  }

  function avpIstanzeCallback(response) {
    console.log(response);
    if (response != null && response.status >= 200 && response.status < 400) {
      setRows(response.data);
    } else {
      setRows([]);
    }
  }

  const columns = [
    {
      field: "status",
      headerName: "",
      width: 20,
      headerClassName: "tableHeader",
      renderCell: (params) => {
        return params.row.sysAttivo ? (
          <div className="tableStatusActive"></div>
        ) : (
          <div className="tableStatusInactive"></div>
        );
      },
    },
    //{ field: 'idAvp', headerName: 'ID', flex: 1, headerClassName: 'tableHeader' },
    {
      field: "descAssistente",
      headerName: selectedLinguaTesto?.AvpListGraphDescription,
      flex: 3,
      headerClassName: "tableHeader",
    },
    {
      field: "codiceAsset",
      headerName: selectedLinguaTesto?.AvpListGraphCodAsset,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "timeout",
      headerName: selectedLinguaTesto?.AvpListGraphTimeout,
      flex: 1,
      headerClassName: "tableHeader",
    },
    {
      field: "nistanze",
      headerName: selectedLinguaTesto?.AvpListGraphNInstance,
      flex: 1,
      headerClassName: "tableHeader",
    },
    {
      field: "action",
      headerName: "",
      flex: 2,
      sortable: false,
      headerClassName: "tableHeader",
      align: "right",
      renderCell: (params) => {
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking

          console.log(params.row);
          const action = event.target.dataset.action;
          if (action == "edit") {
            handleEdit(params.row.idAvp);
          } else if (action == "delete") {
            handleDelete(params.row.idAvp);
          } else if (action == "istanze") {
            handleIstanze(params.row.idAvp);
          } else if (action == "graph") {
            handleGraph(params.row.idAvp);
          } else if (action == "clone") {
            handleClone(params.row.idAvp);
          }
        };

        return (
          <div className="tableActionButton">
            <img
              data-action="graph"
              src="/images/btn_graph.svg"
              title={selectedLinguaTesto?.AvpListIconGraphic}
              onClick={onClick}
            />
            <img
              data-action="clone"
              style={{ width: 35 }}
              title={selectedLinguaTesto?.AvpListIconCloneAVP}
              src="/images/clone_graph.svg"
              onClick={onClick}
            />
            <img
              data-action="edit"
              src="/images/edit_btn.svg"
              title={selectedLinguaTesto?.AvpListIconModify}
              onClick={onClick}
            />
            <img
              data-action="delete"
              data-rowid=""
              src="/images/delete_btn.svg"
              title={selectedLinguaTesto?.AvpListIconDelete}
              onClick={onClick}
            />
            <img
              data-action="istanze"
              data-rowid=""
              src="/images/user_btn.svg"
              title={selectedLinguaTesto?.AvpListIconInstance}
              onClick={onClick}
            />
          </div>
        );
      },
    },
  ];

  function handleNew() {
    const dest = "/avp/0";
    navigate(dest);
  }

  function handleGraph(idAvp) {
    const dest = "/avp/grafo/" + idAvp;
    navigate(dest);
  }

  function handleEdit(idAvp) {
    const dest = "/avp/" + idAvp;
    navigate(dest);
  }

  function handleIstanze(idAvp) {
    const dest = "/avp/istanze?idavp=" + idAvp;
    navigate(dest);
  }

  function handleDelete(idAvp) {
    setIdAvpToDelete(idAvp);
    setDeleteDialogOpen(true);
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogConfirm = () => {
    setDeleteDialogOpen(false);
    apiDeleteAvpAssistente(idAvpToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };
  function handleClone(idAvp) {
    setIdAvpToClone(idAvp);
    setCloneDialogOpen(true);
  }

  const handleCloneDialogClose = () => {
    // setDeleteDialogOpen(false);
    setCloneDialogOpen(false)
  };

  const handleCloneDialogConfirm = () => {
    setCloneDialogOpen(false);
    apiCloneAvpAssistente(idAvpToClone, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };

  return (
    <div id="avp-gestioneavp-screen">
      <AvpHeader selectedMenuId={"avp"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#avp"} />
      <div id="avp-cms-screen-container">
        <Collapse
          in={alertSuccessOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setAlertSuccessOpen(false);
            }, 2000);
          }}
        >
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.AvpListAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.AvpListAlertError}
          </Alert>
        </Collapse>

        <div className="avp-cms-screen-title">
          {selectedLinguaTesto?.AvpListTitle}
        </div>
        <div className="avp-cms-screen-content">
          <div className="avp-cms-screen-toolbar clearfix">
            <div className="avp-cms-screen-toolbar-title">
              {rows.length}&nbsp;{selectedLinguaTesto?.AvpListTitleAvp}
            </div>
            <div className="avp-cms-screen-toolbar-filters"></div>
            <div className="avp-cms-screen-toolbar-add" onClick={handleNew}>
              <button>{selectedLinguaTesto?.AvpListButtonAdd}</button>
            </div>
          </div>

          <DataGrid
            disableColumnMenu
            getRowId={(row) => row.idAvp}
            rows={rows}
            columns={columns}
            getRowClassName={(params) => "tableRow"}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[5]}
            disableRowSelectionOnClick
          />
        </div>
      </div>

      <Dialog
        open={cloneDialogOpen}
        onClose={handleCloneDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {selectedLinguaTesto?.GestioneAvpInstancceDialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.AvpListDialogClone}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloneDialogClose}>
            {selectedLinguaTesto?.AvpListDialogResetClone}
          </Button>
          <Button onClick={handleCloneDialogConfirm} autoFocus>
            {selectedLinguaTesto?.AvpListDialogConfirmClone}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Conferma eliminazione"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.AvpListDialogDelete}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>
            {selectedLinguaTesto?.AvpListDialogResetDelete}
          </Button>
          <Button onClick={handleDeleteDialogConfirm} autoFocus>
            {selectedLinguaTesto?.AvpListDialogConfirmDelete}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
